import { find, filter, map, each, uniq, includes } from "lodash";
import store from "../store";
import { getAllTopicsChronologically } from "./SocialTopicsUtils";
/**
 * Checks if it is a conversation with a trainer
 * @param {object} group the group
 * @return {bool} yes or no
 */ export function isTrainerConversation(group) {
    return group.members.length === 2 && !!find(group.members, function(m) {
        return !!m.name.match(/trainer/gi);
    });
}
export function getGroupLabel(group, myself) {
    var session = store.getState().session;
    return group.name ? group.name : group.members.map(function(member) {
        return member.id === (session === null || session === void 0 ? void 0 : session.id) ? myself : member.name;
    }).join(", ");
}
/**
 * Get's groups filtered by term
 * @param {string} term to filter groups by Name | Members
 * @return {array} Filtered groups
 */ export function getFilteredGroups(term) {
    var groups = store.getState().groups.groups;
    var sRegEx = new RegExp(term, "gi");
    return filter(groups, function(group) {
        return !!group.name && group.name.match(sRegEx) || !!map(group.members, "name").join(" ").match(sRegEx);
    });
}
/**
 * Returns the count of unread Topics from all Groups
 * @returns {number}
 */ export function getUnreadCount() {
    var nc = 0;
    var groups = store.getState().groups.groups;
    each(groups, function(s) {
        nc = s.unread_topics > 0 ? nc + 1 : nc;
    });
    return nc;
}
export function getActiveGroups() {
    var groups = store.getState().groups.groups;
    var grpIds = uniq(map(getAllTopicsChronologically(), "group_id"));
    return filter(groups, function(s) {
        return includes(grpIds, s.id);
    });
}
/**
 * Searches a sphere based on it's ID
 * this may also return the private sphere (for notes), if it matches
 * @param id
 * @returns {Group}
 */ export function getGroup(id) {
    var groups = store.getState().groups;
    var sph1 = groups.groups.filter(function(filter) {
        return filter.id === id;
    })[0];
    var sph2 = groups.noteGroup && groups.noteGroup.id === id ? groups.noteGroup : null;
    return sph1 || sph2;
}
